import iconMarker from "../../../../../../resources/svg/map/map_pointmarker.svg";
import iconRndMarker from "../../../../../../resources/svg/map/map_roundsmarker.svg";
import iconPauseTrackMarker from "../../../../../../resources/svg/map/map_pause.svg";
import iconPlceMarker from "../../../../../../resources/svg/map/map_waypoint.svg";
import iconTracksMarker from "../../../../../../resources/svg/map/map_tracksmarker.svg";
const getSymbol = (
  icon,
  fill = "transparent",
  stroke = "transparent",
  width = 24,
  height = 24
) => {
  return icon.replace(
    /viewBox=".*?"/g,
    'viewBox="0 0 ' +
      width +
      " " +
      height +
      '" width="' +
      width +
      '" height="' +
      height +
      '" style="stroke-width: 2px; stroke: ' +
      stroke +
      "; fill: " +
      fill +
      ';"'
  );
};
export const iconRoundsMarker = getSymbol(
  iconRndMarker,
  "rgba(0,0,0,1)",
  "rgba(255,255,255,1)",
  24
);

/* export const iconTracksMarker = getSymbol(
  iconRndMarker,
  "rgb(255,61,0)",
  "rgba(255,255,255,1)"
); */

export const iconStartMarker = getSymbol(
  iconRndMarker,
  "rgba(26,128,56,1)",
  "rgba(255,255,255,1)",
  24
);

export const iconEndMarker = getSymbol(
  iconRndMarker,
  "rgba(196,32,32,1)",
  "rgba(255,255,255,1)",
  24
);

export const iconPauseMarker = getSymbol(
  iconPauseTrackMarker,
  "rgba(255,129,39,1)",
  "rgba(255,255,255,1)"
);

export const iconWaypointMarker = getSymbol(
  iconPlceMarker,
  "rgba(16,172,64,1)",
  "rgba(255,255,255,1)"
);

export const iconTracksMarkers = getSymbol(iconTracksMarker, "rgb(255,61,0)");

export const iconLocationMarker = getSymbol(
  iconMarker,
  "rgb(17, 102, 238)",
  "white"
);

export const iconDirectionMarker = {
  path: "M.75.91H.5L0,.41l-.5.5H-.75L0,.16Z", // 0,0 is the tip of the arrow
  fillColor: "#ffffff",
  fillOpacity: 1,
  strokeColor: "#000000",
  strokeWeight: 1,
};
